import { render } from "./ProfilesTestedReport.vue?vue&type=template&id=41e6a634"
import script from "./ProfilesTestedReport.vue?vue&type=script&lang=js"
export * from "./ProfilesTestedReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__